import request from '../utils/request'
import { ConstConfig } from '../constants'
const url = process.env.VUE_APP_PASS_API

export function login(userName, password) {
  const data = {
    username: userName,
    password: password,
    remember: 365
  }
  return request({
    url: ConstConfig.authApiPath + '/login.do',
    method: 'post',
    data: data
  })
}

export function smsLogin(userName, smsCode) {
  const data = {
    mobile: userName,
    code: smsCode,
    appId: ConstConfig.wxAppId
  }
  return request({
    url: ConstConfig.apiPath + '/ChangeUserMobile.json',
    method: 'post',
    data: data
  })
}

export function sendSmsCode(userName) {
  const params = {
    mobile: userName,
    platform: 1 // 上操场平台
  }
  return request({
    url: ConstConfig.apiPath + '/GetVerifyCode.json',
    method: 'get',
    params
  })
}

export function bindMobile(loginName, code) {
  const params = {
    loginType: 'mobile',
    loginName: loginName,
    action: 'fastBind',
    sendCode: code,
    link: true
  }
  return request({
    url: ConstConfig.authApiPath + '/registerMobile.do',
    method: 'get',
    params
  })
}

export function logout() {}

export function checkSSO() {
  return request({
    url: ConstConfig.authApiPath + '/checkSSO.do',
    method: 'get'
  })
}

export function loginWechat(code) {
  //     clientId: ConstConfig.client_id
  const params = {
    code: code,
    disableAutoRegister: true
  }
  return request({
    url: url +  ConstConfig.apiPath + '/LoginWechat.json',
    method: 'get',
    params
  })
}

export function getProfile(params) {
  return request({
    url: url + ConstConfig.authApiPath + '/getProfile.do',
    method: 'get',
    params
  })
}

export function loginByMobile(data) {
  return request({
    url: url + ConstConfig.authApiPath  + '/registerMobile.do',
    method: 'post',
    data
  })
}
export function getCode(params) {
  return request({
    url: url + ConstConfig.authApiPath + '/registerMobile.do',
    method: 'get',
    params
  })
}

export function getEmailCode(params) {
  return request({
    url: url + ConstConfig.authApiPath + '/sendFastBindCodeByEmail.do',
    method: 'get',
    params
  })
}

export function fastBindByEmail(params) {
  return request({
    url: url + ConstConfig.authApiPath + '/fastBindByEmail.do',
    method: 'get',
    params
  })
}